import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { SearchComponentSM } from '../../components/shop-management/shop-management-search/shop-management-search.component';
import { WorkOrderGridComponent } from '../../components/shop-management/shop-management-grid/shop-management-grid.component';
import { FiltersComponent } from '../../components/shop-management/shop-management-filters/shop-management-filters.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { WorkOrderSearchTextForm } from '../../form-model/work-order-search-text.form.model';

import { ShopManagementFilterForm } from '../../form-model/shop-management-filter.form.model';
import { RouterLink, RouterModule } from '@angular/router';
@Component({
  selector: 'app-work-order-list-page',
  imports: [
    SearchComponentSM,
    WorkOrderGridComponent,
    FiltersComponent,
    NgxSkeletonLoaderModule,
    ReactiveFormsModule,
    RouterLink,
    RouterModule,
  ],
  templateUrl: './shop-management.component.html',
  styleUrl: './shop-management.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ShopManagementComponent {
  // Array to store selected rows
  filterFormGroup = this.formBuilder.group({
    shopManagementFilterForm: this.formBuilder.group<ShopManagementFilterForm>({} as ShopManagementFilterForm),
    workOrderSearchTextForm: this.formBuilder.group<WorkOrderSearchTextForm>({} as WorkOrderSearchTextForm),
  });

  constructor(private readonly formBuilder: FormBuilder) {}
}
